import { render, staticRenderFns } from "./ModalViewAllDocs.vue?vue&type=template&id=13c9d93f&"
import script from "./ModalViewAllDocs.vue?vue&type=script&lang=js&"
export * from "./ModalViewAllDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports